// ./stores/modelsStore.ts

import { create } from 'zustand'
import { HookResult } from '../hooks/hookTypes'
import axiosInstance, { axiosRequest } from '../network/axiosInstance'

interface ModelConfig {
  id: string
  name: string
  type: string
  identifier: string
  availableCapabilities: string[]
  config: any
  pricing: any
  TopP: number
  Temperature: number
  MaxTokens: number
  isEnabled: boolean
}

interface ModelConfigState {
  configsLoading: boolean
  configsFetchSuccess: boolean
  configsFetchError: boolean
  configs: ModelConfig[] | null
  configsErrorMessage: string | null
  fetchConfigs: () => Promise<void>
}

export const useGetModelConfigs = create<ModelConfigState>((set) => ({
  configsLoading: false,
  configsFetchSuccess: false,
  configsFetchError: false,
  configs: null,
  configsErrorMessage: null,
  fetchConfigs: async () => {
    set({
      configsLoading: true,
      configsFetchSuccess: false,
      configsFetchError: false,
      configs: null,
      configsErrorMessage: null,
    })
    try {
      const res = await axiosInstance.get('/api/modelcfg')
      set({
        configsLoading: false,
        configsFetchSuccess: true,
        configs: res.data.configs,
      })
    } catch (err) {
      console.error('Error fetching model configurations:', err)
      set({
        configsLoading: false,
        configsFetchError: true,
        configsErrorMessage: err.message,
      })
    }
  },
}))

export const useCreateModelConfig = axiosRequest({
  method: 'POST',
  url: '/api/modelcfg',
})

export const useUpdateModelConfig = axiosRequest({
  method: 'PUT',
  url: '/api/modelcfg',
})

export const useDeleteModelConfig = axiosRequest({
  method: 'DELETE',
  url: '/api/modelcfg',
})
